import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import { goto } from '@wheelbox/lithejs-router';
import withTranslations from '@wheelbox/lithejs-i18n';

import { Card } from '@components/ui';
import Icon from '../../components/layout/icon';

import withPageTitle from '../../lib/page';

import examples from './examples.json';

const ExamplesPage: LitheFC = ({
  id = 'examples-page',
  testId = 'examples-page',
}): LitheElement<'main'> => {
  withPageTitle('LitheJS | Examples');

  const t = withTranslations('Examples');

  return [
    'main',
    { id, 'data-testid': testId, class: 'page-grid p-4' },
    [
      'ul',
      {
        class:
          'list-none ps-0 col-span-12 grid grid-cols-1 md:grid-cols-2 l:grid-cols-3 gap-4',
      },
      ...examples.map<LitheElement<'li'>>((example) => [
        'li',
        { class: 'cursor-pointer', onclick: () => goto(example.path) },
        Card(
          {
            classes:
              'h-full p-4 flex flex-col gap-2 hover:shadow-lg transition-shadow',
          },
          Icon({ icon: 'secure', classes: 'w-12 h-12 fill-primary' }),
          ['h3', { class: 'text-xl text-primary' }, t(`${example.id}.title`)],
          ['p', { class: 'text-text' }, t(`${example.id}.description`)]
        ),
      ]),
    ],
  ];
};

export default ExamplesPage;
